import { render, staticRenderFns } from "./ModalAddNewUser.vue?vue&type=template&id=027b6a7e&scoped=true"
import script from "./ModalAddNewUser.vue?vue&type=script&lang=js"
export * from "./ModalAddNewUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027b6a7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('027b6a7e')) {
      api.createRecord('027b6a7e', component.options)
    } else {
      api.reload('027b6a7e', component.options)
    }
    module.hot.accept("./ModalAddNewUser.vue?vue&type=template&id=027b6a7e&scoped=true", function () {
      api.rerender('027b6a7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalAddNewUser.vue"
export default component.exports